export const scrollToRefObject = ref => typeof window !== "undefined" && window.scrollTo(0, ref.current.offsetTop - 100);